import { defineMessages } from "react-intl";

export default defineMessages({
  myProfileDetails: {
    id: "PageViewProfile.MyProfileDetails",
    defaultMessage: "My profile details",
  },
  myProfileDetailsTitle: {
    id: "PageViewProfile.MyProfileDetailsTitle",
    defaultMessage: "My Profile",
  },
  myAccount: {
    id: "PageViewProfile.MySubscription",
    defaultMessage: "My subscription",
  },
  subscriptionManagers: {
    id: "PageViewProfile.SubscriptionManagers",
    defaultMessage: "Subscription managers",
  },
  programmeAdmins: {
    id: "PageViewProfile.ProgrammeAdmins",
    defaultMessage: "Programme admins",
  },
  close: {
    id: "PageViewProfile.Close",
    defaultMessage: "Close",
  },
  back: {
    id: "PageViewProfile.Back",
    defaultMessage: "Back",
  },
  addSubscriptionManager: {
    id: "PageViewProfile.AddSubscriptionManager",
    defaultMessage: "Add subscription manager",
  },
  addProgrammeAdmin: {
    id: "PageViewProfile.AddProgrammeAdmin",
    defaultMessage: "Add programme admin",
  },
  loadingResults: {
    id: "PageViewProfile.LoadingResults",
    defaultMessage: "Loading results",
  },
  noResults: {
    id: "PageViewProfile.NoResults",
    defaultMessage: "No results found",
  },
  loadError: {
    id: "PageViewProfile.LoadError",
    defaultMessage: "An error occurred while performing the operation",
  },
  logout: {
    id: "PageViewProfile.Logout",
    defaultMessage: "Sign out",
  },
  email: {
    id: "PageViewProfile.Email",
    defaultMessage: "Email",
  },
  firstName: {
    id: "PageViewProfile.FirstName",
    defaultMessage: "First name",
  },
  lastName: {
    id: "PageViewProfile.LastName",
    defaultMessage: "Last name",
  },
  password: {
    id: "PageViewProfile.Password",
    defaultMessage: "Password",
  },
  confirmPassword: {
    id: "PageViewProfile.ConfirmPassword",
    defaultMessage: "Confirm password",
  },
  update: {
    id: "PageViewProfile.Update",
    defaultMessage: "Update",
  },
  cancel: {
    id: "PageViewProfile.Cancel",
    defaultMessage: "Cancel",
  },
  role: {
    id: "PageViewProfile.Role",
    defaultMessage: "Role",
  },
  updateUserError: {
    id: "PageViewProfile.UpdateUserError",
    defaultMessage: "Failed to update user profile.",
  },
  updateUserSuccess: {
    id: "PageViewProfile.UpdateUserSuccess",
    defaultMessage: "User profile successfully updated.",
  },
  loadUserError: {
    id: "PageViewProfile.LoadUserError",
    defaultMessage: "Failed to load user profile.",
  },
  LEADER: {
    id: "PageViewProfile.Leader",
    defaultMessage: "Leader",
  },
  SM: {
    id: "PageViewProfile.SubscriptionManager",
    defaultMessage: "Subscription Manager",
  },
  GA: {
    id: "PageViewProfile.GroupAdministrator",
    defaultMessage: "Group Administrator",
  },
});
